<div class="container">
  <div class="row">
    <div class="col-xs-12">
      <h3>Sorry, you are not authorized to login. Please contact system administrator for access.</h3>
    </div>
  </div>
</div>
